import React, { useMemo } from 'react';
import { Box, Text } from '@common-fe/common-fe';
import dayjs from 'dayjs';

import {
  ResendItemStatus,
  ResendItemStatusBackgroundColorMap,
  ResendItemStatusTitlesMap,
} from '../ResendSection.types';

interface Props {
  date: string;
  status: ResendItemStatus;
}
const ResendHistoryList: React.FC<Props> = ({ date, status }) => {
  const month = useMemo(() => {
    return dayjs(date).format('MMM');
  }, [date]);

  const day = useMemo(() => {
    return dayjs(date).format('DD');
  }, [date]);
  const backgroundColor = useMemo(() => {
    return ResendItemStatusBackgroundColorMap[status] || 'infoContainer';
  }, [status]);
  const text = useMemo(() => {
    return ResendItemStatusTitlesMap[status] || 'Not Sent';
  }, [status]);
  return (
    <Box data-testid={`resend-history-item_${status}`} direction="row" align="center" height="40px">
      <Box direction="column">
        <Text
          data-testid={`resend-history-item_${status}_month`}
          color="textDisabled"
          size="small"
          style={{ lineHeight: '18px' }}
        >
          {month}
        </Text>
        <Text data-testid={`resend-history-item_${status}_date`}>{day}</Text>
      </Box>

      <Box
        style={{ flex: 1 }}
        round="container2Round"
        height="32px"
        margin={{ left: 's' }}
        pad={{ left: 'm', top: '6px', bottom: '6px' }}
        background={backgroundColor}
      >
        <Text
          data-testid={`resend-history-item_${status}_text`}
          size="medium"
          weight={400}
          style={{ lineHeight: '20px' }}
        >
          {text}
        </Text>
      </Box>
    </Box>
  );
};

export default ResendHistoryList;
